"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Chapter_1 = __importDefault(require("./Chapter"));
const SinkMetaball_1 = __importDefault(require("../three/element/SinkMetaball"));
class ChapterSink extends Chapter_1.default {
    constructor(stage, text, key) {
        super();
        this.text = text;
        this.key = key;
        this.stage = stage;
        this.mask = null;
    }
    start() {
        this.stage.renderer.setClearColor(0x000000, 1);
        this.stage.grid.setWhite();
        this.stage.camera.position.set(0, 0, 2);
        this.stage.controls.target.set(0, 0, 0);
        this.stage.controls.update();
        this.stage.fixCameraBasePos();
        this.mask = new SinkMetaball_1.default(2, 2, this.stage.cache.get('textSink'));
        this.stage.add(this.mask);
        this.dispatchTextWhite();
        this.showText(1, 'white');
        this.done(5);
    }
    update() {
        var _a;
        (_a = this.mask) === null || _a === void 0 ? void 0 : _a.update();
    }
    stop(cb) {
        var _a;
        (_a = this.mask) === null || _a === void 0 ? void 0 : _a.hide(() => {
            this.mask && this.stage.remove(this.mask);
            this.mask = null;
            cb();
        });
    }
}
exports.default = ChapterSink;
